import apiClient from "./apiClient";

export const fetchVacancies = async () => {
    const response = await apiClient.get("/api/vacancies/all");
    return response.data;
};

export const createVacancy = async (vacancyData) => {
    const response = await apiClient.post("/api/vacancies", vacancyData);
    return response.data;
};

export const updateVacancy = async (id, vacancyData) => {
    const response = await apiClient.put(`/api/vacancies/${id}`, vacancyData);
    return response.data;
};

export const deleteVacancy = async (id) => {
    await apiClient.delete(`/api/vacancies/${id}`);
};